// // LabelDisplay.tsx
// import React, { useEffect, useState } from 'react';
// import { Typography } from '@mui/material';
// import { labelStore } from './LableStore';

// const LabelDisplay = () => {
//   const [label, setLabel] = useState(labelStore.getLabel());

//   useEffect(() => {
//     const unsubscribe = labelStore.subscribe(setLabel);
//     return () => unsubscribe();
//   }, []);

//   return <Typography  variant="h6" fontWeight={700} color="#098963" >{label}</Typography>;
// };

// export default LabelDisplay;




import React, { useEffect, useState } from 'react';
import { Typography, Box } from '@mui/material';
import { labelStore } from './LableStore';

const LabelDisplay = () => {
  const [label, setLabel] = useState(labelStore.getLabel());
  const [icon, setIcon] = useState(labelStore.getIcon());

  useEffect(() => {
    const unsubLabel = labelStore.subscribe(setLabel);
    const unsubIcon = labelStore.subscribeIcon(setIcon);

    return () => {
      unsubLabel();
      unsubIcon();
    };
  }, []);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {icon}
      <Typography fontWeight={700} fontSize="30px">
        {label}
      </Typography>
    </Box>
  );
};

export default LabelDisplay;